export default function (/**@type {ApisauceInstance} */ api) {
  const getAllTmr = (paging) => api.get(`Tmr/search`, paging);

  const addTmr = (payload) => api.post(`Tmr/create`, payload);
  const getTmr = (id) => api.get(`Tmr/get/${id}`);
  const editTmr = ({ payload, id }) => api.put(`Tmr/edit/${id}`, payload);

  const deleteTmr = (id) => api.delete(`Tmr/delete/${id}`);

  return {
    Tmr: {
      getAllTmr,
      addTmr,
      editTmr,
      deleteTmr,
      getTmr,
    },
  };
}
